/**
 * @desc 采购比例分配详情
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export type Response = defs.srm.ResponseDto<defs.srm.SupplierPurchaseRatioResponseDto>;
export function request(sku: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/srm/supplierQuotation/getPurchaseRatio/${sku}`, {
      method: "GET",

      ...options,
    }),
  );
}
